
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[workspaceId]/[projectId]",
      function () {
        return require("private-next-pages/[workspaceId]/[projectId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[workspaceId]/[projectId]"])
      });
    }
  